import { httpAuth } from 'config/apiClient'
import endpoints from 'constants/endpoints'
import { INotification, INotificationList } from 'services/notifications/types'
import { normalizeNotificationList } from 'services/notifications/normalizeNotification'

export async function fetchNotificationsInbox(limit = 20, cursor = ''): Promise<INotificationList> {
  const { data } = await httpAuth.get(endpoints.notificationsInbox(limit, cursor))
  return normalizeNotificationList(data)
}

export async function fetchUnreadNotifications(limit = 20, cursor = ''): Promise<INotificationList> {
  const { data } = await httpAuth.get(endpoints.notificationsUnread(limit, cursor))
  return normalizeNotificationList(data)
}

export async function fetchUnreadCount(): Promise<number> {
  const { data } = await httpAuth.get(endpoints.notificationsUnreadCount)
  return data.unread_count
}

export async function markNotificationsSeen(
  params: { seenKeys: string[] } | { markAll: true }
): Promise<{ success: boolean; unread_count: number; marked: number }> {
  const body = 'seenKeys' in params ? { seen_keys: params.seenKeys } : { mark_all: true }
  const { data } = await httpAuth.put(endpoints.notificationsSeen, body)
  return data
}

export type { INotification }
